import React, { useEffect, useState } from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import SubscriptionForm from "./Stripe/SubscriptionForm";
import CheckoutForm from "./Stripe/CheckoutForm";
import "./scss/style.scss";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";
import ResetPasswordPage from "./ForgotPassword/ForgotPassword";
const stripePromise = loadStripe(
  "pk_test_51RPGzzPxjO6fLbf0OiZMbsjsPmV585Cu5n0FHZV4ORhDCzUeLnDzbww5QYUz0ZlXIlQ7w7MXxxsRDWgVPaPDkstA00RYF8zECW"
);

function App() {
  const queryParams = new URLSearchParams(window.location.search);
  const token = queryParams.get("token");
  console.log(token);

  const isForgotPassword = queryParams.get("isForgotPassword");
  const [clientSecret, setClientSecret] = useState("");
  const [price_id, setPrice_id] = useState("");
  const [subscription_id, setSubscription_id] = useState("");
  const [Loader, setLoader] = useState(false);

  useEffect(() => {
    if (token) {
      setLoader(true);
      fetch(
        "https://myfinancesbackend.usertesting123.co.uk/api/create-subscription",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            planId: "68341775704025159b873d92",
          }),
        }
      )
        .then((res) => res.json())
        .then((data) => {
          setLoader(false);
          if (data) {
            setClientSecret(data.result.clientSecret);
            setPrice_id(data.result.price_id);
            setSubscription_id(data.result.subscriptionId);
          }
        });
    }
  }, []);

  const options = {
    clientSecret: clientSecret,
    appearance: {
      theme: "stripe",
      rules: {
        ".TabLabel": {
          fontWeight: "500",
        },
        ".TermsText": {
          fontSize: "0px",
          display: "none",
          lineHeight: "0px",
        },
      },
    },
  };

  console.log(isForgotPassword);

  return (
    <>
      {Loader ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <div class="spinner-border" role="status">
            <span class="sr-only"></span>
          </div>
        </div>
      ) : (
        <>
          {isForgotPassword ? (
            <ResetPasswordPage />
          ) : (
            <div>
              {clientSecret !== "" && (
                <Elements stripe={stripePromise} options={options}>
                  <CheckoutForm
                    price_id={price_id}
                    subscriptionId={subscription_id}
                  />
                </Elements>
              )}
            </div>
          )}
        </>
      )}
    </>
  );
}

export default App;
